document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("pq-member-redeem")) {
    customElements.define(
      "pq-member-redeem",
      class PqMemberRedeem extends HTMLElement {
        constructor() {
          super();
          this.container = null;
          this.pointsExchangeId = null;
          this.discountType = 1;
          this.code = null;
          this.points = 0;
          this.memberRedeemListItemCopy = null;
          this.stop = false;
          this.showAllItems = false; // 是否显示所有项目
          this.token =
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOjkwMDAwMTY4MywiYWNjZXNzIjoiYWNjZXNzIiwiZXhwIjoxOTAwODA4NTgyfQ.6hdmN-fLW-pOBoQQsGn1DO2JmV8odkekYh2_aH4Rwak";
        }

        async connectedCallback() {
          this.init();
          const memberRedeemModal = this.querySelector(".member-redeem-modal");
          const closeBtn = memberRedeemModal?.querySelector(
            ".member-redeem-modal-close"
          );
          if (closeBtn) {
            closeBtn.addEventListener("click", () => {
              this.closeModal();
            });
          }

          const memberRedeemModalBtnCancel = memberRedeemModal?.querySelector(
            ".member-redeem-modal-btn-cancel"
          );
          if (memberRedeemModalBtnCancel) {
            memberRedeemModalBtnCancel.addEventListener("click", () => {
              this.closeModal();
            });
          }

          const memberRedeemModalBtnRedeem = memberRedeemModal?.querySelector(
            ".member-redeem-modal-btn-redeem"
          );

          if (memberRedeemModalBtnRedeem) {
            memberRedeemModalBtnRedeem.addEventListener("click", async () => {
              if (this.stop) {
                return;
              }
              memberRedeemModalBtnRedeem.classList.add("loading");
              const res = await this.redeem();
              memberRedeemModalBtnRedeem.classList.remove("loading");
              if (res?.discountCode) {
                this.code = res.discountCode;
                const memberRedeemModalCode = memberRedeemModal.querySelector(
                  ".member-redeem-modal-code"
                );
                if (memberRedeemModalCode) {
                  memberRedeemModalCode.classList.remove(
                    "pq-member-redeem__hidden"
                  );
                  const codeSpan = memberRedeemModalCode.querySelector("span");
                  if (codeSpan) {
                    codeSpan.textContent = res.discountCode;
                  }
                }

                const memberRedeemModalPoints = memberRedeemModal.querySelector(
                  ".member-redeem-modal-points"
                );
                if (memberRedeemModalPoints) {
                  memberRedeemModalPoints.classList.add(
                    "pq-member-redeem__hidden"
                  );
                }

                const redeemBtn = memberRedeemModal.querySelector(
                  ".member-redeem-modal-btn-redeem_wrapper"
                );
                if (redeemBtn) {
                  redeemBtn.classList.add("pq-member-redeem__hidden");
                }

                const redeemBtnCopy = memberRedeemModal.querySelector(
                  ".member-redeem-modal-btn-copy"
                );
                if (redeemBtnCopy) {
                  redeemBtnCopy.classList.remove("pq-member-redeem__hidden");
                  redeemBtnCopy.classList.add("pq-member-redeem__flex");
                }

                const redeemRules = memberRedeemModal.querySelector(
                  ".member-redeem-rules"
                );

                window.pq.eventBus.publish(
                  "CHANGE_USER_POINTS_DATA",
                  res.userInfo
                );
              }
            });
          }

          const memberRedeemModalBtnCopy = memberRedeemModal
            ?.querySelector(".member-redeem-modal-btn-copy")
            ?.querySelector("button");
          if (memberRedeemModalBtnCopy) {
            memberRedeemModalBtnCopy.addEventListener("click", () => {
              this.copy();
            });
          }

          window.pq.eventBus.subscribe("RENDER_REDEEM_LIST", (points) => {
            this.canRedeemCoupon(points);
          });
        }

        async redeem() {
          try {
            this.stop = true;
            const res = await this.fetchRedeem({
              pointsExchangeId: this.pointsExchangeId,
            });
            this.stop = false;
            return res;
          } catch (error) {
            this.stop = false;
            window.pqToast.showToast("error", error.message);
          }
        }

        changeUserPoints(res) {
          const userPointData = JSON.parse(
            JSON.stringify(window.pq.userPointData)
          );
          userPointData.currentPoint -= this.points;
          this.canRedeemCoupon(userPointData.currentPoint);
          window.pq.eventBus.publish(
            "CHANGE_USER_POINTS_DATA",
            JSON.parse(JSON.stringify(userPointData))
          );
        }

        canRedeemCoupon(points) {
          const memberRedeemListItem = this.querySelectorAll(
            ".member-redeem-list_item"
          );
          memberRedeemListItem.forEach((item) => {
            const memberRedeemBtnRedeem = item.querySelector(
              ".member-redeem_btn_redeem"
            );
            const memberRedeemBtnDisabled = item.querySelector(
              ".member-redeem_btn_disabled"
            );
            const itemPoints = parseInt(
              item.getAttribute("data-points").trim()
            );

            if (itemPoints <= points) {
              if (memberRedeemBtnRedeem) {
                memberRedeemBtnRedeem.classList.remove(
                  "pq-member-redeem__hidden"
                );
              }
              if (memberRedeemBtnDisabled) {
                memberRedeemBtnDisabled.classList.add(
                  "pq-member-redeem__hidden"
                );
              }
            } else {
              if (memberRedeemBtnRedeem) {
                memberRedeemBtnRedeem.disabled = true;
              }
              if (memberRedeemBtnDisabled) {
                memberRedeemBtnDisabled.classList.remove(
                  "pq-member-redeem__hidden"
                );
              }
            }
          });
        }

        copy() {
          window.pq.copyToClipboard(this.code);
          // 跳转到首页
          window.location.href = "/";
        }

        handleScroll() {
          const memberRedeemScrollContainer = this.querySelector(
            ".member-redeem-scroll-container"
          );
          const memberRedeemModalBtnRedeemWrapper = this.querySelector(
            ".member-redeem-modal-btn-redeem_wrapper"
          );
          const memberRedeemModalBtn = this.querySelector(
            ".member-redeem-modal-btn"
          );

          if (
            memberRedeemScrollContainer &&
            memberRedeemScrollContainer.scrollTop +
              memberRedeemScrollContainer.clientHeight >=
              memberRedeemScrollContainer.scrollHeight
          ) {
            if (memberRedeemModalBtnRedeemWrapper) {
              memberRedeemModalBtnRedeemWrapper.classList.add(
                "pq-member-redeem__border-t"
              );
            }
            if (memberRedeemModalBtn) {
              memberRedeemModalBtn.style.boxShadow = "none";
            }
          } else {
            if (memberRedeemModalBtnRedeemWrapper) {
              memberRedeemModalBtnRedeemWrapper.classList.remove(
                "pq-member-redeem__border-t"
              );
            }
            if (memberRedeemModalBtn) {
              memberRedeemModalBtn.style.boxShadow = "0 0 4px 0px #0000001a";
            }
          }
        }

        showModal(type, data, points, coverUrl, button) {
          const memberRedeemModal = this.querySelector(".member-redeem-modal");
          if (!memberRedeemModal) return;
          // 如果 button 在 data 对象中，从 data 中获取
          const buttonElement = button || data?.redeemBtn || data?.button;
          if (buttonElement) {
            buttonElement.classList.remove("loading");
          }
          window.pq.scrollDisable();
          memberRedeemModal.classList.remove("pq-member-redeem__hidden");
          memberRedeemModal.classList.add("pq-member-redeem__flex");

          const redeemRules = memberRedeemModal.querySelector(
            ".member-redeem-rules"
          );
          if (redeemRules) {
            redeemRules.innerHTML = data.rules;
            redeemRules.style.whiteSpace = "pre-wrap";
          }

          if (type === "redeem") {
            const redeemBtn = memberRedeemModal.querySelector(
              ".member-redeem-modal-btn"
            );
            if (redeemBtn) {
              redeemBtn.classList.remove("pq-member-redeem__hidden");
              redeemBtn.classList.add("pq-member-redeem__flex");
            }

            const redeemPart = memberRedeemModal.querySelector(
              ".member-redeem-modal-btn-redeem_wrapper"
            );
            if (redeemPart) {
              redeemPart.classList.remove("pq-member-redeem__hidden");
            }

            const redeemBtnCopy = memberRedeemModal.querySelector(
              ".member-redeem-modal-btn-copy"
            );
            if (redeemBtnCopy) {
              redeemBtnCopy.classList.add("pq-member-redeem__hidden");
            }

            // 重置兑换按钮的 disabled 状态，并根据用户积分重新判断
            const redeemButton = memberRedeemModal.querySelector(
              ".pq-member-redeem-detail__btn-redeem"
            );
            const redeemTitle = memberRedeemModal.querySelector(
              ".pq-member-redeem-detail__btn-redeem-title"
            );

            if (redeemButton && redeemTitle) {
              // 先获取当前产品的积分要求和用户当前积分
              const requiredPoints = data?.points || 0;
              const userCurrentPoints =
                window.pq?.userPointData?.currentPoint || 0;

              // 先重置为可用状态和显示标题
              redeemButton.disabled = false;
              redeemTitle.style.display = "block";

              // 根据用户积分重新判断是否应该禁用
              if (requiredPoints > userCurrentPoints) {
                // 积分不足，禁用按钮并隐藏标题
                redeemButton.disabled = true;
                redeemTitle.style.display = "none";
              }
            }

            if (redeemBtn) {
              const redeemBtnHeight = redeemBtn.offsetHeight;
              const redeemBtnStyle = getComputedStyle(redeemBtn);
              const redeemBtnPaddingBottom =
                parseInt(redeemBtnStyle.paddingBottom.replace("px", "")) || 0;
              const redeemBtnPaddingTop =
                parseInt(redeemBtnStyle.paddingTop.replace("px", "")) || 0;
            }

            this.handleScroll();
          } else {
            // rules 类型：检查用户积分是否足够兑换
            const redeemButton = memberRedeemModal.querySelector(
              ".pq-member-redeem-detail__btn-redeem"
            );
            const redeemTitle = memberRedeemModal.querySelector(
              ".pq-member-redeem-detail__btn-redeem-title"
            );

            if (redeemButton && redeemTitle) {
              // 先获取当前产品的积分要求和用户当前积分
              const requiredPoints = data?.points || 0;
              const userCurrentPoints =
                window.pq?.userPointData?.currentPoint || 0;

              // 先重置为可用状态和显示标题
              redeemButton.disabled = false;
              redeemTitle.style.display = "block";

              // 根据用户积分判断是否应该禁用
              if (requiredPoints > userCurrentPoints) {
                // 积分不足，禁用按钮并隐藏标题
                redeemButton.disabled = true;
                redeemTitle.style.display = "none";
              }
            }

            // 隐藏复制按钮（规则查看模式下不需要复制功能）
            const redeemBtn = memberRedeemModal.querySelector(
              ".pq-member-redeem-detail__btn-copy-wrapper"
            );
            if (redeemBtn) {
              redeemBtn.classList.remove("pq-member-redeem__flex");
              redeemBtn.classList.add("pq-member-redeem__hidden");
            }
          }

          const modalImg = memberRedeemModal.querySelector(
            ".member-redeem-modal-img"
          );
          if (modalImg) {
            modalImg.setAttribute("src", data.coverUrl);
          }

          const modalTitle = memberRedeemModal.querySelector(
            ".member-redeem-modal-title"
          );
          if (modalTitle) {
            modalTitle.textContent = data.title;
          }

          const modalPoints = memberRedeemModal.querySelector(
            ".member-redeem-modal-points"
          );
          if (modalPoints) {
            const pointsSpan = modalPoints.querySelector("span");
            if (pointsSpan) {
              pointsSpan.textContent = data.points;
            }
            modalPoints.classList.remove("pq-member-redeem__hidden");
          }

          const modalCode = memberRedeemModal.querySelector(
            ".member-redeem-modal-code"
          );
          if (modalCode) {
            modalCode.classList.add("pq-member-redeem__hidden");
          }
        }

        closeModal() {
          const memberRedeemModal = this.querySelector(".member-redeem-modal");
          if (memberRedeemModal) {
            memberRedeemModal.classList.add("pq-member-redeem__hidden");
            memberRedeemModal.classList.remove("pq-member-redeem__flex");
          }
          window.pq.enableScroll();
          console.log("closeModal2");
        }

        // 获取兑换列表
        async getMemberRedeem(data) {
          const url = "/shopify/userExchange/page";
          const res = await window.pq.http.post(url, {
            data: {
              ...data,
              orderBy: "sort",
              order: "asc",
            },
          });
          if (res.code === 200) {
            return res.data;
          } else {
            return null;
            // throw new Error(window.i18n.error_message_timeout);
          }
        }

        // 兑换
        async fetchRedeem(data) {
          const url = "/shopify/userExchange/exchangeDiscount";
          const res = await window.pq.http.post(url, {
            data,
          });
          if (res.code === 200) {
            window.pqToast.showToast("success", window.i18n.redeem_success);
            return res.data;
          } else {
            throw new Error(window.i18n.redeem_error);
          }
        }

        renderRedeem(res) {
          const _this = this;
          const memberRedeemList = this.querySelector(".member-redeem-list");
          if (!memberRedeemList) return;

          let memberRedeemListItems = memberRedeemList.querySelectorAll(
            ".member-redeem-list_item"
          );

          // 复制memberRedeemListItems
          if (
            !this.memberRedeemListItemCopy &&
            memberRedeemListItems.length > 0
          ) {
            this.memberRedeemListItemCopy =
              memberRedeemListItems[0].cloneNode(true);
          }

          if (res.records.length === 0) {
            if (this.discountType === 1) {
              const discountEmpty = this.querySelector(
                ".member-redeem-discount-empty"
              );
              if (discountEmpty) {
                discountEmpty.classList.remove("pq-member-redeem__hidden");
              }
            } else {
              const productEmpty = this.querySelector(
                ".member-redeem-product-empty"
              );
              if (productEmpty) {
                productEmpty.classList.remove("pq-member-redeem__hidden");
              }
            }
          } else {
            const discountEmpty = this.querySelector(
              ".member-redeem-discount-empty"
            );
            if (discountEmpty) {
              discountEmpty.classList.add("pq-member-redeem__hidden");
            }
            const productEmpty = this.querySelector(
              ".member-redeem-product-empty"
            );
            if (productEmpty) {
              productEmpty.classList.add("pq-member-redeem__hidden");
            }
          }

          // 删除原来的
          memberRedeemList.innerHTML = "";

          res.records.forEach((item) => {
            if (!this.memberRedeemListItemCopy) return;

            const memberRedeemListItem =
              this.memberRedeemListItemCopy.cloneNode(true);
            memberRedeemListItem.setAttribute("data-point-id", item.id);
            memberRedeemListItem.setAttribute("data-points", item.usePoints);

            const img =
              memberRedeemListItem.querySelector(".member-redeem-img");
            if (img && item.coverUrl) {
              img.setAttribute("src", item.coverUrl);
            }

            const title = memberRedeemListItem.querySelector(
              ".member-redeem-title"
            );
            if (title) {
              title.textContent = item.exchangeName;
            }

            const points = memberRedeemListItem.querySelector(
              ".member-redeem-points"
            );
            if (points) {
              const pointsSpan = points.querySelector("span");
              if (pointsSpan) {
                pointsSpan.textContent = item.usePoints;
              }
            }

            memberRedeemList.appendChild(memberRedeemListItem);
          });

          memberRedeemList.classList.add("pq-member-redeem__grid-desktop");
          memberRedeemList.classList.remove("pq-member-redeem__hidden");
          memberRedeemList.classList.add("pq-member-redeem__grid-mobile");

          memberRedeemListItems = memberRedeemList.querySelectorAll(
            ".member-redeem-list_item"
          );

          if (window.pq?.userPointData) {
            const userPointData = JSON.parse(
              JSON.stringify(window.pq?.userPointData)
            );
            this.canRedeemCoupon(userPointData?.currentPoint);
          }

          // 重置显示状态
          this.showAllItems = false;

          // 根据屏幕宽度设置默认显示数量
          // 默认是 8 个，1440 以下是 6 个，768 以下是 4 个，580 以下是 8 个
          const browserWidth = window.innerWidth;
          let defaultDisplayCount;
          if (browserWidth >= 1440) {
            defaultDisplayCount = 8;
          } else if (browserWidth >= 768) {
            defaultDisplayCount = 6;
          } else if (browserWidth >= 580) {
            defaultDisplayCount = 4;
          } else {
            defaultDisplayCount = 8;
          }

          const memberRedeemListItemsLength = memberRedeemListItems.length;

          memberRedeemListItems.forEach((item, index) => {
            // 根据屏幕宽度默认只显示指定数量的项目，如果已展开则显示全部
            if (!this.showAllItems && index >= defaultDisplayCount) {
              item.classList.add("pq-member-redeem__hidden");
            } else {
              item.classList.remove("pq-member-redeem__hidden");
            }

            const redeemBtn = item.querySelector(".member-redeem_btn_redeem");
            const rules = res.records[index].ruleDesc;
            const title = res.records[index].exchangeName;
            const points = res.records[index].usePoints;
            const coverUrl = res.records[index].coverUrl;

            if (redeemBtn) {
              redeemBtn.addEventListener("click", () => {
                if (window.customer) {
                  redeemBtn.classList.add("loading");
                  _this.pointsExchangeId = item.getAttribute("data-point-id");
                  _this.points = points;
                  _this.showModal("redeem", {
                    rules,
                    title,
                    points,
                    coverUrl,
                    redeemBtn,
                  });
                } else {
                  window.pq.openAccountDrawer("login-register", "login");
                }
              });
            }

            const rulesBtn = item.querySelector(".member-redeem-rules-btn");
            if (rulesBtn) {
              rulesBtn.addEventListener("click", () => {
                _this.rules = res.records[index].ruleDesc;
                _this.showModal("rules", {
                  rules,
                  title,
                  points,
                  coverUrl,
                });
              });
            }
          });

          // 管理"查看更多"按钮的显示/隐藏和点击事件
          const viewMoreRedeem = this.querySelector(".view-more_redeem");

          // 移除旧的事件监听器（如果存在）
          if (this.viewMoreRedeemHandler) {
            if (viewMoreRedeem) {
              viewMoreRedeem.removeEventListener(
                "click",
                this.viewMoreRedeemHandler
              );
            }
          }

          if (memberRedeemListItemsLength <= defaultDisplayCount) {
            // 如果项目数量 <= 默认显示数量，隐藏"查看更多"按钮，并显示所有项目
            if (viewMoreRedeem) {
              viewMoreRedeem.classList.add("pq-member-redeem__hidden");
            }
            // 确保所有项目都显示
            memberRedeemListItems.forEach((item) => {
              item.classList.remove("pq-member-redeem__hidden");
            });
          } else {
            // 如果项目数量 > 默认显示数量，显示"查看更多"按钮
            if (viewMoreRedeem) {
              viewMoreRedeem.classList.remove("pq-member-redeem__hidden");
              // 创建点击事件处理函数
              this.viewMoreRedeemHandler = () => {
                this.showAllItems = true;
                // 显示所有项目
                const allItems = memberRedeemList.querySelectorAll(
                  ".member-redeem-list_item"
                );
                allItems.forEach((item) => {
                  item.classList.remove("pq-member-redeem__hidden");
                });
                // 隐藏"查看更多"按钮
                viewMoreRedeem.classList.add("pq-member-redeem__hidden");
              };
              // 添加点击事件，展开显示所有项目
              viewMoreRedeem.addEventListener(
                "click",
                this.viewMoreRedeemHandler
              );
            }
          }
        }

        showLoading() {
          const memberRedeemList = this.querySelector(".member-redeem-list");
          if (memberRedeemList) {
            memberRedeemList.classList.add("pq-member-redeem__hidden");
            memberRedeemList.classList.remove("pq-member-redeem__grid-desktop");
            memberRedeemList.classList.remove("pq-member-redeem__grid-mobile");
          }

          const memberRedeemLoading = this.querySelector(
            ".member-redeem-loading"
          );
          if (memberRedeemLoading) {
            memberRedeemLoading.classList.remove("pq-member-redeem__hidden");
            memberRedeemLoading.classList.add("pq-member-redeem__flex");
          }

          const discountEmpty = this.querySelector(
            ".member-redeem-discount-empty"
          );
          if (discountEmpty) {
            discountEmpty.classList.add("pq-member-redeem__hidden");
          }

          const productEmpty = this.querySelector(
            ".member-redeem-product-empty"
          );
          if (productEmpty) {
            productEmpty.classList.add("pq-member-redeem__hidden");
          }
        }

        hideLoading() {
          const memberRedeemLoading = this.querySelector(
            ".member-redeem-loading"
          );
          if (memberRedeemLoading) {
            memberRedeemLoading.classList.add("pq-member-redeem__hidden");
            memberRedeemLoading.classList.remove("pq-member-redeem__flex");
          }
        }

        init() {
          const _this = this;
          this.showLoading();

          this.getMemberRedeem({
            discountType: this.discountType,
            status: 1,
            page: 1,
            pageSize: 999,
          })
            .then((res) => {
              this.hideLoading();
              _this.renderRedeem(res);
            })
            .catch((err) => {
              this.hideLoading();
              if (window.pq?.showToast) {
                window.pqToast.showToast("error", window.i18n.request_failed);
              }
              if (_this.discountType === 1) {
                const discountEmpty = _this.querySelector(
                  ".member-redeem-discount-empty"
                );
                if (discountEmpty) {
                  discountEmpty.classList.remove("pq-member-redeem__hidden");
                }
              } else {
                const productEmpty = _this.querySelector(
                  ".member-redeem-product-empty"
                );
                if (productEmpty) {
                  productEmpty.classList.remove("pq-member-redeem__hidden");
                }
              }
            });

          const discountTab = this.querySelectorAll("[data-discount-type]");
          discountTab.forEach((tab) => {
            tab.addEventListener("click", function () {
              const discountType = this.getAttribute("data-discount-type");
              if (_this.discountType != discountType) {
                _this.showLoading();
                _this.discountType = discountType;
                _this
                  .getMemberRedeem({
                    discountType: discountType,
                    status: 1,
                    page: 1,
                    pageSize: 999,
                  })
                  .then((res) => {
                    _this.hideLoading();
                    _this.renderRedeem(res);
                    discountTab.forEach((t) => {
                      t.classList.remove("pq-member-redeem__tab-item--active");
                    });
                    this.classList.add("pq-member-redeem__tab-item--active");
                  })
                  .catch((err) => {
                    _this.hideLoading();
                    window.pqToast.showToast(
                      "error",
                      window.i18n.request_failed
                    );
                    if (_this.discountType === 1) {
                      const discountEmpty = _this.querySelector(
                        ".member-redeem-discount-empty"
                      );
                      if (discountEmpty) {
                        discountEmpty.classList.remove("hidden");
                      }
                    } else {
                      const productEmpty = _this.querySelector(
                        ".member-redeem-product-empty"
                      );
                      if (productEmpty) {
                        productEmpty.classList.remove("hidden");
                      }
                    }
                  });
              }
            });
          });
        }
      }
    );
  }
});
